import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ComplianceSetting } from './compliance-setting';
import { PrimaryTrade } from './primary-trade';

export class TradeSpecificCompliance extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static TradeSpecificComplianceProperties: (
    | {
        property: keyof TradeSpecificCompliance;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof TradeSpecificCompliance;
        type: 'alias';
      }
    | {
        property: keyof TradeSpecificCompliance;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'PrimaryTradeId', type: 'column', dataType: 'number' },
    { property: 'ComplianceSettingId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    {
      property: 'ComplianceSetting',
      model: 'ComplianceSetting',
      type: 'association'
    },
    { property: 'PrimaryTrade', model: 'PrimaryTrade', type: 'association' }
  ];

  static {
    TradeSpecificCompliance.TradeSpecificComplianceProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          TradeSpecificCompliance.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          TradeSpecificCompliance.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          TradeSpecificCompliance.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(TradeSpecificComplianceObject: Partial<TradeSpecificCompliance>) {
    super();

    TradeSpecificCompliance.TradeSpecificComplianceProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = TradeSpecificComplianceObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  PrimaryTradeId?: number;
  ComplianceSettingId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  ComplianceSetting?: ComplianceSetting;
  PrimaryTrade?: PrimaryTrade;
}
